export interface PaginationMeta {
  current_page: number;
  last_page: number;
  total: number;
}

interface PaginationProps {
  meta: PaginationMeta | null | undefined;
  onPage: (page: number) => void;
}

export default function Pagination({ meta, onPage }: PaginationProps) {
  if (!meta || meta.last_page <= 1) return null;
  return (
    <div className="pagination">
      <button
        className="btn btn-ghost"
        disabled={meta.current_page <= 1}
        onClick={() => onPage(meta.current_page - 1)}
      >
        ← Prev
      </button>
      <span>
        Page {meta.current_page} of {meta.last_page} ({meta.total} total)
      </span>
      <button
        className="btn btn-ghost"
        disabled={meta.current_page >= meta.last_page}
        onClick={() => onPage(meta.current_page + 1)}
      >
        Next →
      </button>
    </div>
  );
}
